// src/components/etc/VendorBalance.jsx
import React, { useEffect, useState } from "react";
import api from "../../api";
import styles from "./VendorBalance.module.css";

export default function VendorBalance() {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 필터 상태
  const [fiscalYear, setFiscalYear] = useState("2025");
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState("2025-12-31");
  const [selectedAccount, setSelectedAccount] = useState("전체");
  const [selectedVendor, setSelectedVendor] = useState("전체");
  const [vendorOptions, setVendorOptions] = useState([]);

  // ✅ 거래처 목록 불러오기
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await api.get("/vendors/");
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.results || [];
        setVendorOptions(data);
      } catch (err) {
        console.error("❌ 거래처 목록 불러오기 실패:", err);
      }
    };
    fetchVendors();
  }, []);

  // ✅ 조회 버튼 클릭 시 실행되는 함수
  const handleSearch = async () => {
    try {
      setLoading(true);
      console.log("📡 거래처 잔액 불러오는 중...");
      const res = await api.get("/vendors/balances/", {
        params: {
          fiscal_year: fiscalYear,
          start_date: startDate,
          end_date: endDate,
          account: selectedAccount,
          vendor: selectedVendor,
        },
      });
      console.log("✅ 서버 응답:", res.data);
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.results || [];
      setBalances(data);
    } catch (err) {
      console.error("❌ 거래처 잔액 불러오기 실패:", err);
      alert("서버에서 거래처 잔액을 불러올 수 없습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e, setter) => {
    setter(e.target.value);
  };

  return (
    <div className={styles.container}>
      <h2>거래처별 잔액 현황</h2>

      {/* 🔸 필터 박스 */}
      <div className={styles.filterBox}>
        <div className={styles.filterRow}>
          {/* 당기 */}
          <div className={styles.filterItem}>
            <label>당기</label>
            <select
              value={fiscalYear}
              onChange={(e) => handleFilterChange(e, setFiscalYear)}
            >
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div>

          {/* 기간 */}
          <div className={styles.filterItem}>
            <label>기간</label>
            <div className={styles.dateRange}>
              <input
                type="date"
                value={startDate}
                onChange={(e) => handleFilterChange(e, setStartDate)}
              />
              <span>~</span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => handleFilterChange(e, setEndDate)}
              />
            </div>
          </div>

          {/* 계정과목 */}
          <div className={styles.filterItem}>
            <label>계정과목</label>
            <select
              value={selectedAccount}
              onChange={(e) => handleFilterChange(e, setSelectedAccount)}
            >
              <option value="전체">전체</option>
              <option value="미수금">미수금</option>
              <option value="미지급금">미지급금</option>
            </select>
          </div>

          {/* 거래처 */}
          <div className={styles.filterItem}>
            <label>거래처</label>
            <select
              value={selectedVendor}
              onChange={(e) => handleFilterChange(e, setSelectedVendor)}
            >
              <option value="전체">전체 거래처</option>
              {vendorOptions.map((v) => (
                <option key={v.id} value={v.name}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>

          {/* ✅ 조회 버튼 추가 */}
          <button className={styles.searchButton} onClick={handleSearch}>
            조회
          </button>
        </div>
      </div>

      {/* 🔸 테이블 */}
      {loading ? (
        <p>잔액 데이터를 불러오는 중입니다...</p>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>
                <input type="checkbox" />
              </th>
              <th>Code</th>
              <th>거래처명</th>
              <th>전기(월)이월</th>
              <th>차변(₩)</th>
              <th>대변(₩)</th>
              <th>잔액(₩)</th>
            </tr>
          </thead>

          <tbody>
            {balances.length > 0 ? (
              balances.map((v) => {
                const debit = v.debit || 0;
                const credit = v.credit || 0;
                const carry = v.carry_forward || 0;
                const balance = credit - debit; // ✅ 잔액 계산식

                console.log(
                  `🧮 ${v.name} → 대변:${credit}, 차변:${debit}, 잔액:${balance}`
                );

                return (
                  <tr key={v.id}>
                    <td>
                      <input type="checkbox" />
                    </td>
                    <td>{v.code || "-"}</td>
                    <td>{v.name}</td>
                    <td>{carry.toLocaleString()}</td>
                    <td className={styles.debit}>{debit.toLocaleString()}</td>
                    <td className={styles.credit}>{credit.toLocaleString()}</td>
                    <td
                      className={
                        balance >= 0 ? styles.positive : styles.negative
                      }
                    >
                      {balance.toLocaleString()}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  거래처 잔액 데이터가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
